import { DigitalProductStoreBottomSheetQuantityField } from './QuantityField'
import { validationSchema } from './validationSchema'

const DigitalProductStoreBottomSheetForm = {
  QuantityField: DigitalProductStoreBottomSheetQuantityField,
  validationSchema: validationSchema
}

export { DigitalProductStoreBottomSheetForm }
